import React from "react";
import withFirebase from "./withFirebase";
const AuthUserContext = React.createContext(null);

const withAuthentication = Component => {
  class WithAuthentication extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        authUser: null
      };
    }

    componentDidMount() {
      console.log("WithAuthentication");
      console.log(this.props.db);
      this.listener = this.props.firebase.auth.onAuthStateChanged(authUser => {
        console.log(authUser);
        if (authUser) {
          let userVar = false;
          if (!authUser.isAnonymous) {
            this.props.db
              .collection("users")
              .doc(authUser.uid)
              .onSnapshot(doc => {
                userVar = authUser;
                if (doc.exists) {
                  // if (
                  //   !doc.data.playerIds.exists ||
                  //   doc.data.playerIds === "" ||
                  //   doc.data.playerIds.length === 0 ||
                  //   doc.data.playerIds === null
                  // ) {
                  //   this.props.db
                  //     .collection("users")
                  //     .doc(authUser.uid)
                  //     .update({
                  //       playerIds: this.state.playerIds
                  //     });
                  // }
                  console.log("already Exist");
                  userVar.db = doc.data();
                } else {
                  console.log("New User about to be added");
                  this.props.db
                    .collection("users")
                    .doc(authUser.uid)
                    .set({
                      userId: authUser.uid,
                      name: authUser.displayName,
                      email: authUser.email,
                      imageURL: authUser.photoURL,
                      role: ""
                    });
                }
                this.setState({ authUser: userVar });
              });
          } else this.setState({ authUser });
          localStorage.setItem("user", authUser);
          this.setState({ authUser });
        } else this.setState({ authUser: null });
      });
    }

    componentWillUnmount() {
      console.log(1);
      this.listener();
    }

    render() {
      return (
        <AuthUserContext.Provider value={this.state.authUser}>
          <Component {...this.props} />
        </AuthUserContext.Provider>
      );
    }
  }

  return withFirebase(WithAuthentication);
};

export { AuthUserContext };
export default withAuthentication;
